// web/src/lib/api/gdrive.ts

// 1. Herramienta para crear carpetas reales
export const createDriveFolder = async (token: string, folderName: string): Promise<string> => {
    const metadata = {
        name: folderName,
        mimeType: 'application/vnd.google-apps.folder'
    };

    const response = await fetch('https://www.googleapis.com/drive/v3/files', {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(metadata)
    });

    if (!response.ok) throw new Error('Fallo al crear la carpeta en Drive');
    const data = await response.json();
    return data.id; // Nos devuelve el ID real de la carpeta creada
};

// 2. Herramienta para subir el archivo (Preparado para la Queue List)
export const uploadBlobToDrive = (
    token: string, 
    fileBlob: Blob, 
    fileName: string, 
    folderId: string = "",
    onProgress?: (porcentaje: number) => void
): Promise<any> => {
    return new Promise((resolve, reject) => {
        const metadata: any = { name: fileName };
        if (folderId && folderId !== "") {
            metadata.parents = [folderId]; // Lo mete en la carpeta elegida
        }

        const form = new FormData();
        form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
        form.append('file', fileBlob);

        // Usamos XMLHttpRequest en lugar de fetch para poder enviar el progreso en vivo a la Queue List
        const xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart');
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);

        // Chivato de progreso que actualiza la barra
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable && onProgress) {
                const percentComplete = Math.round((event.loaded / event.total) * 100);
                onProgress(percentComplete);
            }
        };

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(JSON.parse(xhr.responseText));
            } else {
                reject(new Error('Fallo al subir el archivo: ' + xhr.responseText));
            }
        };

        xhr.onerror = () => reject(new Error('Error de red al subir a Drive'));
        
        xhr.send(form);
    });
};